import React, { useContext, useEffect, useState } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { ReactComponent as CalendarDots } from '../../../../assets/icons/v3/calendar-dots.svg';
import { ReactComponent as Files } from '../../../../assets/icons/v3/files.svg';
import StyledTable from '../../../../shared/components/v3/Table/StyledTable/StyledTable';
import { CompanyContext } from '../../../../shared/context/company/companyContext';
import { getMappedReports } from '../../../../shared/handlers/dataMapper';
import { REPORTS_PAYROLL_TABLE_COLUMNS } from '../../../../shared/handlers/tableColumns';
import { IReport } from '../../../../shared/interfaces/reports';
import { TRANSLATIONS_REPORTS } from '../../../../shared/translations/reports';
import { sortArray } from '../../../../shared/utils/utils';

import '../ReportsTable.scss';

export const PayrollReportsTable = () => {
  const [reports, setReports] = useState<IReport[]>([]);
  const { companyRFCycles, isLoadingRFCycles, errorGettingRFCycles } = useContext(CompanyContext);
  const { t } = useTranslation();

  const sortData = (columnKey: string, isAscending: boolean) => {
    let sorted: IReport[] = [];
    if (columnKey === 'generationDate') {
      sorted = sortArray([...reports], 'period', isAscending) as IReport[];
    } else {
      sorted = sortArray([...reports], columnKey, isAscending) as IReport[];
    }
    setReports(sorted);
  };

  useEffect(() => {
    if (companyRFCycles?.payRollCycles) {
      setReports(getMappedReports(companyRFCycles.payRollCycles));
    } else {
      setReports([]);
    }
  }, [companyRFCycles]);

  return (
    <div className="reports-tabs-container">
      <div className="flex flex-row items-center justify-between mb-4">
        <div className="reports-title">{t(TRANSLATIONS_REPORTS.rf.payroll.title)}</div>
        <div className="reports-info flex flex-row">
          <div className="reports-frecuency flex flex-row items-center gap-3">
            <CalendarDots className="calendar-dots" />
            <span className="reports-frecuency-label">
              <Trans i18nKey={TRANSLATIONS_REPORTS.frequency.monthly} components={{ b: <b></b> }} />
            </span>
          </div>
          <div className="reports-format flex flex-row items-center gap-3">
            <Files />
            <span className="reports-format-label">
              <Trans i18nKey={TRANSLATIONS_REPORTS.formatXls} components={{ b: <b></b> }} />
            </span>
          </div>
        </div>
      </div>
      <div className="reports-description mb-16">{t(TRANSLATIONS_REPORTS.rf.payroll.description)}</div>
      <StyledTable
        data={reports}
        columns={REPORTS_PAYROLL_TABLE_COLUMNS}
        sortData={sortData}
        error={errorGettingRFCycles}
        loading={isLoadingRFCycles}
        emptyCard={{
          primaryText: TRANSLATIONS_REPORTS.table.emptyState.title,
          secondaryText: TRANSLATIONS_REPORTS.table.emptyState.description
        }}
      />
    </div>
  );
};

export default PayrollReportsTable;
